export interface GeoCoordinates {
  latitude: number;
  longitude: number;
}

// Whether a result carries a mappable point. `null` is the backend's own "no coordinates" signal — it
// already turns provider sentinels (e.g. IP2Location's 0,0 for "unknown") into null — so (0, 0) that
// reaches the page is a real coordinate and stays valid. Anything non-finite or out of range is
// treated as absent rather than handed to Leaflet.
export function toMapCoordinates(latitude: number | null | undefined, longitude: number | null | undefined): GeoCoordinates | null {
  if (typeof latitude !== "number" || typeof longitude !== "number") return null;
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) return null;
  return { latitude, longitude };
}

// The coordinate label shown on (and instead of) the map — three decimals, i.e. roughly 100 m, which is
// already finer than any IP geolocation actually is.
export function formatMapCoordinates(latitude: number, longitude: number): string {
  return `${latitude.toFixed(3)}, ${longitude.toFixed(3)}`;
}
